import { render, staticRenderFns } from "./DataInputDict.vue?vue&type=template&id=29e4e6ce&"
import script from "./DataInputDict.vue?vue&type=script&lang=js&"
export * from "./DataInputDict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports